import type { AutoMatchResult } from '@dcc-erp/shared';
import { Icon } from '@dcc-erp/ui';

interface Props {
  statementId: string | null;
  statementLabel: string;
  result?: AutoMatchResult | undefined;
  isPending: boolean;
  onRun: () => void;
  onClose: () => void;
}

export function AutoMatchModal({
  statementId,
  statementLabel,
  result,
  isPending,
  onRun,
  onClose,
}: Props) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,15,20,0.45)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 100,
        padding: 24,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white',
          borderRadius: 12,
          width: 620,
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            padding: '18px 22px',
            borderBottom: '1px solid var(--border)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>
            <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Auto-match</h3>
            <div className="meta" style={{ marginTop: 2 }}>
              จับคู่รายการ statement ↔ ใบสำคัญบัญชีเงินฝาก อัตโนมัติ
            </div>
          </div>
          <button className="btn ghost" onClick={onClose} style={{ padding: '0 8px' }}>
            <Icon name="x" size={18} />
          </button>
        </div>
        <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14 }}>
          {statementId ? (
            <div
              style={{ padding: '12px 14px', background: '#fafafa', borderRadius: 6, fontSize: 14 }}
            >
              <b>{statementLabel}</b>
            </div>
          ) : (
            <div
              style={{ padding: '12px 14px', background: '#fef3e8', borderRadius: 6, fontSize: 14 }}
            >
              ยังไม่ได้เลือก statement — ไปแท็บ "ภาพรวมทุกบัญชี" แล้วเลือกบัญชีที่นำเข้า statement
              แล้วก่อน
            </div>
          )}
          <div
            style={{
              padding: 14,
              border: '1px solid var(--border)',
              borderRadius: 8,
              fontSize: 14,
              lineHeight: 1.6,
            }}
          >
            <div className="section-title" style={{ margin: '0 0 6px' }}>
              เกณฑ์การจับคู่
            </div>
            จับคู่รายการที่ <b>จำนวนเงินตรงกัน</b> และ <b>วันที่ห่างกันไม่เกิน ±3 วัน</b>{' '}
            กับใบสำคัญบัญชีเงินฝากที่ POSTED แล้ว · รายการกำกวม (ผู้สมัครหลายตัวระยะวันเท่ากัน)
            จะถูกข้ามไว้ให้จับคู่เอง
          </div>
          {result && (
            <div
              style={{
                padding: '12px 14px',
                background: '#e7f4ec',
                border: '1px solid #bbdebf',
                borderRadius: 8,
                fontSize: 14,
              }}
            >
              <div style={{ color: 'var(--positive)', fontWeight: 600 }}>
                จับคู่สำเร็จ {result.matched} รายการ
              </div>
              <div className="meta" style={{ marginTop: 2 }}>
                เหลือ {result.remaining} รายการ · ผู้สมัครที่พิจารณา {result.candidates} รายการ
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            padding: '14px 22px',
            borderTop: '1px solid var(--border)',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
          }}
        >
          <button className="btn ghost" onClick={onClose}>
            ปิด
          </button>
          <button className="btn primary" disabled={!statementId || isPending} onClick={onRun}>
            <Icon name="link" size={14} /> เริ่ม Auto-match
          </button>
        </div>
      </div>
    </div>
  );
}
